import GET_CURRENCY from '@/graphql/Currency/getCurrency.gql';
import { graphClient } from '../main';

export default class CurrencyResource {
    async get () {
        return await graphClient.query({
            query: GET_CURRENCY,
            update: data => data.currencies
        })
    }
}